import React from 'react';
import { testDesignView as TestDesignView } from './testDesignView';
import { fetch } from '../../modules/httpServices';
import APP from '../../modules/index';
import axios from 'axios';
import { cloneDeep } from 'lodash';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import mammoth from "mammoth";

class TestDesignComponent extends React.Component {
  constructor(props) {
    super(props);
    this.controller = null;
    this.isAborted = false;
    this.state = {
      requirementVal: '',
      requirementValStep2: '',
      uploadedData: '',
      imageData: '',
      allImagesData: [],
      fileName: '',
      businessVal: {},
      configOptionData: [],
      configId: '',
      assessmentAverageScore: '',
      showRequirement: true,
      feedbackTag: '',
      selectedProvider: '',
      selectedModel: "",
      llmModels: {},
      feedbackTagOption: [
        { id: 'missingEdgeCase', displayLabel: 'Missing Edge Case', value: 'missingEdgeCase'},
        { id: 'dataVariation', displayLabel: 'Data Variation', value: 'dataVariation',},
        { id: 'multiAPIFlow', displayLabel: 'Multi-API Flow', value: 'multiAPIFlow'},
        { id: 'security', displayLabel: 'Security', value: 'security'},
        { id: 'performance', displayLabel: 'Performance', value: 'performance'},
        { id: 'negativeCoverage', displayLabel: 'Negative Coverage', value: 'negativeCoverage'},
        { id: 'regression', displayLabel: 'Regression', value: 'regression'},
        { id: 'compliance', displayLabel: 'Compliance', value: 'compliance'}
      ],
      feedbackType: '',
      feedbackTypeOption: [
        {id: 'add', displayLabel: 'Add', value: 'Add'},
        { id: 'edit', displayLabel: 'Edit', value: 'Edit'},
        { id: 'delete', displayLabel: 'Delete', value: 'Delete' },
        { id: 'regenerate', displayLabel: 'Regenerate', value: 'Regenerate'}
      ],
      isLoading: false,
      isLoadingStep2: false,
      isLoadingButton: false,
      requirementRadio: 'jira',
      requirementTestRadio: '',
      feedbackDescription: '',
      requirementAppRadio: 'new',
      openErrorModal: false,
      showReGenerateData: false,
      openModalGeneration: false,
      jiraBooleanCheck: false,
      countVal: false,
      showDoc: true,
      accuracy: '',
      startFrom: 'requirement',
      showStep1Data: false,
      showStep2Data: false,
      showStep3Data: false,
      showDocError: true,
      jiraVal: '',
      jiraCheck: false,
      documentVal: '',
      openModal: false,
      showBusiness: false,
      scenarioConvention: '',
      scenarioType: '',
      errorMessage: '',
      applicationData: [],
      appOptions: [],
      chatGptData: [],
      apiTitle: '',
      endpointURI: '',
      testid: '',
      programmingLanguageVersion: '',
      programmingLanguage: '',
      framework: '',
      uiframework: '',
      browsersOrDevices: '',
      automationTools: '',
      testConvention: '',
      businessRules: '',
      openApiSpec: '',
      requirementUnderstanding: '',
      testcases: '',
      htmllizedTestcases: '',
      htmlizedTestcases: '',
      generatedTest: ''
    };
  }

  componentDidMount() {
    const checkIdData = JSON.parse(sessionStorage.getItem('checkId'));
    this.fetchAllIntegrationData();
    this.fetchLlmConfig();
    if (checkIdData && checkIdData?.tcCode !== null) {
      document.getElementById('firstli').classList.remove('is-active');
      document.getElementById('thirdli').classList.add('is-active');
      this.setState({
        showBusiness: false,
        showRequirement: false,
        showStep1Data: false,
        showFinalData: true,
        showStep3Data: true,
        showStep2Data: checkIdData.startFrom === 'testcases' ? true : false,
        showReGenerateData: true,
        jiraCheck: checkIdData.jiraId ? true : false,
        requirementTestRadio: checkIdData.appType || 'api',
        requirementUnderstanding: checkIdData.requirementUnderstanding || '',
        startFrom: checkIdData.startFrom || 'requirement',
        requirementVal: checkIdData.requirement,
        requirementValStep2: checkIdData.requirementValStep2 || '',
        scenarioConvention: checkIdData.scenarioConvention || '',
        scenarioType: checkIdData.scenarioType || '',
        testcases: checkIdData.tcScenario,
        generatedTest: checkIdData.tcScenario,
        testid: checkIdData.id,
        jiraVal: checkIdData.jiraId,
        selectedProvider: localStorage.getItem('selectedProvider') || '',
        selectedModel: localStorage.getItem('selectedModel') || '',
        htmllizedTestcases: checkIdData.htmlTcScenario,
        htmlizedTestcases: checkIdData.htmlTcScenario,
        businessRules: checkIdData.businessRules,
        testCodeOutput: checkIdData.tcCode
      });
    } else if (checkIdData && checkIdData.tcScenario !== null) {
      document.getElementById('firstli').classList.remove('is-active');
      document.getElementById('secondli').classList.add('is-active');
      const { totalScore, averageScore } = checkIdData.startFrom === 'testcases' ? { totalScore: '', averageScore: '' } : this.getAggregatedAssessmentScore(JSON.parse(checkIdData.tcScenario || checkIdData?.generatedTests || []));
      this.setState({
        showBusiness: true,
        showRequirement: false,
        showStep1Data: false,
        showStep2Data: checkIdData.startFrom === 'testcases' ? true : false,
        requirementVal: checkIdData.requirement,
        requirementValStep2: checkIdData.requirementValStep2 || '',
        requirementUnderstanding: checkIdData.requirementUnderstanding || '',
        requirementTestRadio: checkIdData.appType || 'api',
        startFrom: checkIdData.startFrom || 'requirement',
        testcases: checkIdData.tcScenario,
        generatedTest: checkIdData.tcScenario,
        scenarioConvention: checkIdData.scenarioConvention || '',
        scenarioType: checkIdData.scenarioType || '',
        testid: checkIdData.id,
        jiraVal: checkIdData.jiraId,
        jiraCheck: checkIdData.jiraId ? true : false,
        assessmentAverageScore: averageScore,
        selectedProvider: localStorage.getItem('selectedProvider') || '',
        selectedModel: localStorage.getItem('selectedModel') || '',
        htmllizedTestcases: checkIdData.htmlTcScenario,
        htmlizedTestcases: checkIdData.htmlTcScenario,
        businessRules: checkIdData.businessRules,
        apiTitle: checkIdData.tcName
      });
    } else {
    }
    document.body.addEventListener("click", function (e) {

      if (e.target.id === "btnSelectAll") {
        document.querySelectorAll('.tc-checkbox').forEach(cb => cb.checked = true);
      }

      if (e.target.id === "btnDeselectAll") {
        document.querySelectorAll('.tc-checkbox').forEach(cb => cb.checked = false);
      }

      if (e.target.id === "btnGenerateJSON") {
        const selected = [];
        document.querySelectorAll('.tc-checkbox:checked').forEach(cb => {
          selected.push(JSON.parse(cb.dataset.json));
        });
      }
    });
  }
f
  handleChangellm = (e) => {
    const [provider, model] = e.target.value.split("|");
    localStorage.removeItem('selectedProvider');
    localStorage.removeItem('selectedModel');
    this.setState({
      selectedProvider: provider,
      selectedModel: model
    });
  };

  fetchLlmConfig = () => {
    const token = localStorage.getItem('AceToken');
      const orgId = localStorage.getItem('OrgId');
      const aceBackendUrl = localStorage.getItem('AceBackendUrl');
      // this.setState({ isLoadingButton: true });
      fetch.post({
        url: APP.Constants.SERVICE_URLS.LLM_CONFIG,
        requestBody: { token, orgId, aceBackendUrl },
        callbackHandler: (res) => {
          const { status, payload } = res;
          if (APP.Constants.SUCCESS === status) {
            const { defaultLlmProvider, llmModels } = payload;
            const providerModels = llmModels?.[defaultLlmProvider] || {};
            const defaultModel = Object.keys(providerModels)[0] || '';
            this.setState({
              selectedProvider: defaultLlmProvider,
              selectedModel: defaultModel,
              llmModels
            });

          } else {
            this.setState({ errorMessage: 'Failed to fetch LLM configuration', openErrorModal: true});
          }
        }
      });
  }

  fetchAllIntegrationData = () => {
    const userId = localStorage.getItem("userid");
    fetch.get({
      url: APP.Constants.SERVICE_URLS.INTEGRATION_NEW + userId,
      callbackHandler: (res) => {
        const { status, payload } = res;
        if (APP.Constants.SUCCESS === status) {
          const configOption = payload?.map((opt) => ({ id: opt.id, displayLabel: opt.configName, value: opt.id }));
          this.setState({ configOptionData: configOption });
        } else {
          this.setState({ configOptionData: [] });
        }
      }
    });
  }

  onChange = ({ eve, id, value }) => {
    const _state = cloneDeep(this.state);
    _state[id] = value;
    if (id === 'requirementTestRadio' && value === 'api') {
      _state.requirementRadio = 'jira';
    }
    if (id === 'requirementTestRadio') {
      _state.requirementVal = '';
    }
    this.setState(_state);
  };

  onCancel = () => {
    this.setState({ requirementVal: '', showStep1Data: false, jiraCheck: false });
  };

  isEditorEmpty = (value) => {
    if (!value) return true;
    const stripped = value.replace(/<[^>]*>/g, '').trim(); // remove HTML
    return stripped === '';
  };

  onCancelStep2 = () => {
    this.setState({ requirementValStep2: '', showStep2Data: false, jiraCheck: false });
  };

  onAbort = () => {
    this.isAborted = true;
    if (this.controller) {
      this.controller.abort();
    }
    this.setState({
      showStep1Data: false,
      showStep2Data: false,
      jiraCheck: false,
      isLoading: false,
      isLoadingStep2: false,
      errorMessage: 'aborted',
      openErrorModal: true
    });
  };
  closePopup = () => {
    this.setState({ openModal: false });
  };
  openPopup = () => {
    this.setState({ openModal: true, jiraVal: '', configId: '', showDocError: true });
  };

  openNewModal = (type) => {
    this.setState({ openModalGeneration: true, modalType: type });
  }
  closeNewModal = () => {
    this.setState({ openModalGeneration: false });
  }

  getAggregatedAssessmentScore = (testCases) => {
    if (!Array.isArray(testCases) || testCases.length === 0) return 0;

    const total = testCases.reduce((sum, item) => sum + (item.assessmentScore || 0), 0);
    const average = total / testCases.length;

    return {
      totalScore: total,
      averageScore: Number(average.toFixed(2)),
    };
  };

  gotoStep2Data = () => {
    const { apiTitle, openApiSpec, businessRules, endpointURI, requirementTestRadio, requirementUnderstanding, requirementVal, imageData, scenarioConvention, scenarioType, selectedProvider, selectedModel } = this.state;
    this.setState({ isLoadingButton: true });
    let URL;
    let RequestBody;
    if (requirementTestRadio === 'web' || requirementTestRadio === 'mobile') {
      URL = APP.Constants.SERVICE_URLS.SHOW_WEB_STEP2;
      RequestBody = {
        requirement: requirementVal,
        requirementUnderstanding: requirementUnderstanding,
        scenarioType,
        scenarioConvention,
        provider: selectedProvider, 
        model: selectedModel,
        imgs64: imageData === '' ? [] : imageData
      }
    } else {
      URL = APP.Constants.SERVICE_URLS.SHOW_STEP2;
      RequestBody = {
        apiTitle,
        businessRules,
        requirement: requirementVal,
        openApiSpec,
        endpointURI,
        provider: selectedProvider, 
        model: selectedModel,
        scenarioType,
        scenarioConvention

      }
    }
    fetch.post({
      url: URL,
      requestBody: RequestBody,
      callbackHandler: (res) => {
        const { status, payload } = res;
        if (APP.Constants.SUCCESS === status) {
          document.getElementById('firstli').classList.remove('is-active');
          document.getElementById('secondli').classList.add('is-active');
          const { totalScore, averageScore } = this.getAggregatedAssessmentScore(JSON.parse(payload?.testcases || payload?.generatedTests || []));
          this.setState({
            showBusiness: true,
            showRequirement: false,
            showStep1Data: false,
            showStep3Data: false,
            showFinalData: false,
            assessmentAverageScore: averageScore,
            testcases: payload?.testcases,
            htmllizedTestcases: payload?.htmllizedTestcases,
            generatedTest: payload?.generatedTests,
            htmlizedTestcases: payload?.htmlizedTestcases,
            isLoadingButton: false
          });
        } else {
          this.setState({
            openErrorModal: true,
            isLoadingButton: false,
            errorMessage: status
          });
        }
      }
    });
  };

  generateCode = () => {
    const {
      programmingLanguage,
      framework,
      testConvention,
      testcases,
      uiframework,
      browsersOrDevices,
      automationTools,
      generatedTest,
      openApiSpec,
      requirementTestRadio,
      requirementUnderstanding,
      requirementVal,
      imageData,
      startFrom,
      scenarioConvention,
      selectedModel,
      selectedProvider,
      scenarioType
    } = this.state;
    document.getElementById('secondli').classList.remove('is-active');
    document.getElementById('firstli').classList.remove('is-active');
    document.getElementById('thirdli').classList.add('is-active');
    // const selected = [];
    // document.querySelectorAll('.tc-checkbox:checked').forEach(cb => {
    //   selected.push(JSON.parse(cb.dataset.json));
    // });
    // const testcasesSelected = selected.length > 0 ? selected : testcases;
    this.setState({ isLoading: true });
    fetch.post({
      url: APP.Constants.SERVICE_URLS.CHECK_API_DATA,
      requestBody: { prompt: (requirementTestRadio === 'web' || requirementTestRadio === 'mobile') && startFrom === 'requirement' ? requirementVal : testcases },
      callbackHandler: (res) => {
        const { status, payload } = res;
        if (APP.Constants.SUCCESS === status) {
          if (payload === 'garbage') {
            this.setState({
              openErrorModal: true,
              isLoading: false,
              errorMessage: 'junk'
            });
          } else {
            let URL;
            let RequestBody;
            if (startFrom === 'testcases') {
              URL = APP.Constants.SERVICE_URLS.SHOW_MANUAL_STEP2;
              RequestBody = {
                englishTestcases: testcases,
                platformType: requirementTestRadio,
                framework,
                uiframework,
                browsersOrDevices,
                automationTools,
                programmingLanguage,
                provider: selectedProvider, 
                model: selectedModel,
                testConvention
              }
            } else if (requirementTestRadio === 'web' || requirementTestRadio === 'mobile') {
              URL = APP.Constants.SERVICE_URLS.SHOW_WEB_STEP3;
              RequestBody = {
                requirement: requirementVal,
                requirementUnderstanding: requirementUnderstanding,
                scenarioType,
                scenarioConvention,
                platformType: requirementTestRadio,
                framework,
                uiframework,
                browsersOrDevices,
                automationTools,
                programmingLanguage,
                provider: selectedProvider, 
                model: selectedModel,
                testConvention,
                imgs64: imageData === '' ? [] : imageData
              }
            } else {
              URL = APP.Constants.SERVICE_URLS.SHOW_STEP3;
              RequestBody = {
                englishTestcases: testcases,
                framework,
                openApiSpec,
                provider: selectedProvider, 
                model: selectedModel,
                programmingLanguage,
                testConvention
              }
            }
            fetch.post({
              url: URL,
              requestBody: RequestBody,
              callbackHandler: (res) => {
                const { status, payload } = res;
                if (APP.Constants.SUCCESS === status) {
                  this.setState({
                    showFinalData: true,
                    showBusiness: false,
                    testCodeOutput: payload?.generatedTests,
                    showStep3Data: true,
                    showReGenerateData: true,
                    isLoading: false
                  });
                } else {
                  this.setState({
                    openErrorModal: true,
                    isLoading: false,
                    errorMessage: status
                  });
                }
              }
            });
          }
        }
      }
    })
  };

  gotoStep3Data = () => {
    const userMail = localStorage.getItem("email");
    const orgId = localStorage.getItem('OrgId');
    const projectId = localStorage.getItem('ProjectId');
    if (this.state.testid === '') {
      const { testcases, requirementVal, apiTitle, jiraVal, htmllizedTestcases, requirementUnderstanding, generatedTest, htmlizedTestcases, businessRules, startFrom, requirementTestRadio, requirementValStep2, selectedModel, selectedProvider, scenarioConvention, scenarioType } =
        this.state;
      fetch.post({
        url: APP.Constants.SERVICE_URLS.GPT_SAVE_API,
        requestBody: {
          requirement: requirementVal,
          appType: requirementTestRadio,
          tcName: apiTitle,
          jiraId: jiraVal,
          businessRules,
          scenarioConvention,
          scenarioType,
          startFrom,
          requirementValStep2,
          requirementUnderstanding,
          htmlTcScenario: requirementTestRadio === 'api' ? htmllizedTestcases : htmlizedTestcases,
          tcScenario: testcases || generatedTest,
          actionType: 'TestDesign',
          userName: userMail,
          provider: selectedProvider,
          model: selectedModel,
          orgId,
          projectId
        },
        callbackHandler: (res) => {
          const { status, payload } = res;
          if (APP.Constants.SUCCESS === status) {
            document.getElementById('secondli').classList.remove('is-active');
            document.getElementById('thirdli').classList.add('is-active');
            this.setState({
              showFinalData: true,
              showBusiness: false,
              countVal: false,
              testid: payload.id,
              isLoading: false
            });
          } else {
            this.setState({
              openErrorModal: true,
              isLoading: false,
              errorMessage: status
            });
          }
        }
      });
    } else {
      document.getElementById('secondli').classList.remove('is-active');
      document.getElementById('thirdli').classList.add('is-active');
      this.setState({
        showFinalData: true,
        showBusiness: false,
        isLoading: false
      });
    }
  };
  reGenerateScenario = () => {
    const { testid, requirementTestRadio, requirementVal, imageData, scenarioConvention, scenarioType, selectedModel, selectedProvider } = this.state;

  }
  assessQuality = () => {
    fetch.post({
      url: APP.Constants.SERVICE_URLS.ASSESS_QUALITY,
      requestBody: {
        // requirement: requirementVal,
      },
      callbackHandler: (res) => {
        const { status, payload } = res;
        if (APP.Constants.SUCCESS === status) {
        } else {
        }
      }
    });
  };

  backtostep1 = () => {
    if (
      document.getElementById('secondli').classList.value !== '' ||
      document.getElementById('thirdli').classList.value !== ''
    ) {
      document.getElementById('secondli').classList.remove('is-active');
      document.getElementById('thirdli').classList.remove('is-active');
      document.getElementById('firstli').classList.add('is-active');
      sessionStorage.removeItem('checkId');
      const check = this.state.startFrom === 'testcases' ? false : true;
      this.setState({
        showBusiness: false,
        showRequirement: true,
        showStep1Data: check,
        startFrom: 'requirement',
        showFinalData: false,
        showStep2Data: false,
        showStep3Data: false
      });
    }
  };
  backtostepui1 = () => {
    if (document.getElementById('secondli').classList.value !== '' ||
      document.getElementById('thirdli').classList.value !== '') {
      document.getElementById('secondli').classList.remove('is-active');
      document.getElementById('thirdli').classList.remove('is-active');
      document.getElementById('firstli').classList.add('is-active');
      sessionStorage.removeItem('checkId');
      const check = this.state.startFrom === 'testcases' ? false : true;
      this.setState({
        showBusiness: false,
        showRequirement: true,
        showStep1Data: check,
        showStep2Data: false,
        startFrom: 'requirement',
        showFinalData: false
      });
    }
  };
  backtostepui2 = () => {
    if (document.getElementById('thirdli').classList.value !== '') {
      document.getElementById('thirdli').classList.remove('is-active');
      document.getElementById('secondli').classList.add('is-active');
      sessionStorage.removeItem('checkId');
      this.setState({
        showBusiness: true,
        showFinalData: false,
        showStep3Data: false
      });
    }
  };
  backtostep2 = () => {
    if (document.getElementById('thirdli').classList.value !== '') {
      document.getElementById('thirdli').classList.remove('is-active');
      document.getElementById('secondli').classList.add('is-active');
      sessionStorage.removeItem('checkId');
      this.setState({
        showBusiness: true,
        showFinalData: false,
        showStep3Data: false
      });
    }
  };

  onChangeRadioButton = (val, eve, id) => {
    const _state = { ...this.state };
    _state[id] = val;
    if (id === 'startFrom' && val === 'testcases') {
      document.getElementById('firstli').classList.remove('is-active');
      document.getElementById('secondli').classList.add('is-active');
      _state.showBusiness = true;
      _state.showRequirement = false;
      _state.showStep1Data = false;
      _state.showStep3Data = false;
      _state.showFinalData = false;
      _state.isLoadingButton = false;
    }
    this.setState(_state);
  };

  // handleFile = (file) => {
  //   const reader = new FileReader();
  //   reader.readAsDataURL(file);
  //   reader.onload = (e) => {
  //     this.setState({ imageData: e.target.result, showDocError: false, fileName: file?.name });
  //   };
  // };
  handleFile = (files) => {
  const fileReaders = [];
  const images = [];
  const payloadImgs = [];

  files.forEach((file, index) => {
    const reader = new FileReader();

    reader.readAsDataURL(file);

    reader.onload = (e) => {
      images.push({
        base64: e.target.result,
        name: file.name,
      });

      payloadImgs.push(e.target.result);

      // When all readers are done, update state
      if (images.length === files.length) {
        this.setState({
          imageData: payloadImgs,
          allImagesData: images,   // array of images
          showDocError: false,
        });
      }
    };

    fileReaders.push(reader);
  });
};



  onUpload = async (event) => {
    try {
      const file = event.target.files[0];

      if (!file) return;


      if (!file.name.toLowerCase().endsWith(".docx")) {
        alert("Please upload a .docx file");
        return;
      }

      this.setState({ isLoadingButton: true });


      const arrayBuffer = await file.arrayBuffer();


      const result = await mammoth.extractRawText({
        arrayBuffer: arrayBuffer
      });

      this.setState({
        uploadedData: result.value,
        showDocError: false,
        isLoadingButton: false
      });

    } catch (err) {
      console.error("DOCX parse error:", err);
      this.setState({ isLoadingButton: false });
    }

    
};
  onDone = () => {
    this.setState({ isLoading: true });
    const { requirementVal, requirementTestRadio, requirementAppRadio, imageData, selectedProvider, selectedModel } = this.state;
    let RequestBody;
    let URL;
    this.isAborted = false; // ✅ reset
    this.controller = new AbortController();
    const signal = this.controller.signal;
    if (requirementTestRadio === 'web' || requirementTestRadio === 'mobile') {
      RequestBody = { requirement: requirementVal, reqType: requirementTestRadio, imgs64: imageData === '' ? [] : imageData, appDevType: requirementAppRadio, provider: selectedProvider, model: selectedModel }
      URL = APP.Constants.SERVICE_URLS.SHOW_WEB_STEP1
    } else {
      RequestBody = { requirement: requirementVal, reqType: requirementTestRadio, provider: selectedProvider, model: selectedModel }
      URL = APP.Constants.SERVICE_URLS.SHOW_STEP1
    }
    fetch.post({
      url: APP.Constants.SERVICE_URLS.CHECK_API_DATA,
      requestBody: { prompt: requirementVal },
      callbackHandler: (res) => {
        if (this.isAborted) return;
        const { status, payload } = res;
        if (APP.Constants.SUCCESS === status) {
          if (payload === 'garbage') {
            this.setState({
              openErrorModal: true,
              isLoading: false,
              errorMessage: 'junkerror'
            });
          } else {
            fetch.postSignal({
              url: URL,
              requestBody: RequestBody,
              signal: signal,
              callbackHandler: (res) => {
                if (this.isAborted) return;
                const { status, payload } = res;
                if (res instanceof DOMException && res.name === 'AbortError') {
                  this.setState({
                    errorMessage: 'aborted',
                    openErrorModal: true,
                    isLoading: false
                  });
                  return;
                } else if (APP.Constants.SUCCESS === status) {
                  if (payload?.requirementUnderstanding === null && (requirementTestRadio === 'web' || requirementTestRadio === 'mobile')) {
                    this.setState({
                      openErrorModal: true,
                      isLoading: false,
                      errorMessage: 'failureReq'
                    });
                  } else if ((payload?.businessRules === "No business rules found." || payload?.businessRules === '') && requirementTestRadio === 'api') {
                    this.setState({
                      openErrorModal: true,
                      isLoading: false,
                      errorMessage: 'failureReq'
                    });
                  } else {
                    this.setState({
                      showStep1Data: true,
                      apiTitle: payload?.apiTitle,
                      endpointURI: payload?.endpointURI,
                      businessRules: payload?.businessRules,
                      openApiSpec: payload?.openApiSpec,
                      requirementUnderstanding: payload?.requirementUnderstanding,
                      isLoading: false
                    });
                  }
                } else {
                  fetch.postSignal({
                    url: URL,
                    requestBody: RequestBody,
                    signal: signal,
                    callbackHandler: (res) => {
                      const { status, payload } = res;
                      if (res instanceof DOMException && res.name === 'AbortError') {
                        console.log("Request was aborted");
                      } else if (APP.Constants.SUCCESS === status) {
                        if (payload?.requirementUnderstanding === null) {
                          this.setState({
                            openErrorModal: true,
                            isLoading: false,
                            errorMessage: 'failureReq'
                          });
                        } else {
                          this.setState({
                            showStep1Data: true,
                            apiTitle: payload?.apiTitle,
                            endpointURI: payload?.endpointURI,
                            businessRules: payload?.businessRules,
                            openApiSpec: payload?.openApiSpec,
                            requirementUnderstanding: payload?.requirementUnderstanding,
                            isLoading: false
                          });
                        }
                      } else {
                        this.setState({
                          openErrorModal: true,
                          isLoading: false,
                          errorMessage: status
                        });
                      }
                    }
                  });
                }
              }
            });
          }
        }
      }
    })
  };

  onAnalyze = () => {
    this.setState({ isLoadingStep2: true });
    const { requirementValStep2, requirementTestRadio, requirementAppRadio, selectedModel, selectedProvider } = this.state;
    let URL;
    this.isAborted = false; // ✅ reset
    this.controller = new AbortController();
    const signal = this.controller.signal;
    fetch.post({
      url: APP.Constants.SERVICE_URLS.CHECK_API_DATA,
      requestBody: { prompt: requirementValStep2 },
      callbackHandler: (res) => {
        if (this.isAborted) return;
        const { status, payload } = res;
        if (APP.Constants.SUCCESS === status) {
          if (payload === 'garbage') {
            this.setState({
              openErrorModal: true,
              isLoadingStep2: false,
              errorMessage: 'junkerr'
            });
          } else {
            fetch.postSignal({
              url: APP.Constants.SERVICE_URLS.SHOW_MANUAL_STEP1,
              requestBody: { englishTestcases: requirementValStep2, reqType: requirementTestRadio, provider: selectedProvider, model: selectedModel },
              signal: signal,
              callbackHandler: (res) => {
                if (this.isAborted) return;
                const { status, payload } = res;
                if (res instanceof DOMException && res.name === 'AbortError') {
                  this.setState({
                    errorMessage: 'aborted',
                    openErrorModal: true,
                    isLoading: false
                  });
                  return;
                } else if (APP.Constants.SUCCESS === status) {
                  this.setState({
                    showStep2Data: true,
                    testcases: payload?.generatedTests,
                    generatedTest: payload?.generatedTests,
                    isLoadingStep2: false
                  });
                } else {
                  this.setState({
                    openErrorModal: true,
                    isLoadingStep2: false,
                    errorMessage: status
                  });
                }
              }
            });
          }
        }
      }
    })
  };

  closeErrorPopup = (msg) => {
    this.setState({
      openErrorModal: false,
      errorMessage: ''
    }, () => {
      if (msg === 'junk') {
        document.getElementById('firstli').classList.remove('is-active');
        document.getElementById('thirdli').classList.add('is-active');
      } else if (msg === 'junkerr') {
        document.getElementById('firstli').classList.remove('is-active');
        document.getElementById('secondli').classList.add('is-active');
        this.setState({ requirementValStep2: '' });
      } else if (msg === 'junkerror' || msg === 'failureReq') {
        this.setState({ requirementVal: '' });
      }
    });
  };

  submitRequirement = () => {
    const _state = cloneDeep(this.state);
    if (_state.requirementRadio === 'jira') {
      const projectManagement = localStorage.getItem('projectManagement');
      const activeConfigId = localStorage.getItem('activeConfigId');
      const aceToken = localStorage.getItem('AceToken');
      const orgId = localStorage.getItem('OrgId');
      const aceBackendUrl = localStorage.getItem('AceBackendUrl');
      this.setState({ isLoadingButton: true });
      fetch.post({
        url: APP.Constants.SERVICE_URLS.JIRA_INTEGRATION,
        requestBody: { projectManagement, aceToken, orgId, aceBackendUrl, configId: activeConfigId, id: this.state.jiraVal },
        callbackHandler: (res) => {
          const { status, payload } = res;
          if (APP.Constants.SUCCESS === status) {
            if (payload.errorMessage === null) {
              const data = `<b>Title:</b> ${payload.summary === null ? '' : payload.summary}<br /><br />
              <b>Description:</b> ${payload.description === null ? '' : payload.description}<br />`;
              this.setState({
                requirementVal: _state.startFrom === 'requirement' ? data : '',
                requirementValStep2: _state.startFrom === 'testcases' ? data : '',
                openModal: false,
                isLoadingButton: false,
                jiraCheck: true
              });
            } else {
              // alert(payload.errorMessage);
              toast.error(`${payload.errorMessage}`, { theme: 'colored' });
              this.setState({
                requirementVal: '',
                requirementValStep2: '',
                openModal: false,
                isLoadingButton: false
              });
            }
          } else {
            this.setState({ requirementVal: '', requirementValStep2: '', isLoadingButton: false });
          }
        }
      });
    } else {
      this.setState({
        requirementVal: _state.startFrom === 'requirement' ? _state.uploadedData : '',
        requirementValStep2: _state.startFrom === 'testcases' ? _state.uploadedData : '',
        openModal: false,
        jiraCheck: false
      });
    }
  };

  redirectToAnotherPage = () => {
    sessionStorage.removeItem('checkId');
    this.props.goToPage(APP.Constants.ROUTES.DESIGN_HOME);
  };

  reGenerateCode = () => {
    sessionStorage.removeItem('checkId');
    this.setState({ showReGenerateData: false, countVal: false });
  };

  feedbackRequirement = () => {
    document.querySelectorAll('.tc-checkbox').forEach(cb => cb.checked = true);
    const selected = [];
    document.querySelectorAll('.tc-checkbox:checked').forEach(cb => {
      selected.push(JSON.parse(cb.dataset.json));
    });
    const { apiTitle, openApiSpec, businessRules, endpointURI, requirementTestRadio, requirementUnderstanding, requirementVal, imageData, scenarioConvention, scenarioType, feedbackDescription, feedbackTag, feedbackType, selectedModel, selectedProvider } = this.state;
    this.setState({ isLoadingButton: true });
    let URL;
    let RequestBody;
    if (requirementTestRadio === 'web' || requirementTestRadio === 'mobile') {
      URL = APP.Constants.SERVICE_URLS.SHOW_WEB_STEP2;
      RequestBody = {
        requirement: requirementVal,
        requirementUnderstanding: requirementUnderstanding,
        scenarioType,
        scenarioConvention,
        feedbackDesc: feedbackDescription,
        feedbackTags: [feedbackTag] || [],
        feedbackType,
        provider: selectedProvider, 
        model: selectedModel,
        existingTCs: `${JSON.stringify(selected)}`,
        imgs64: imageData === '' ? [] : imageData
      }
    } else {
      URL = APP.Constants.SERVICE_URLS.SHOW_STEP2;
      RequestBody = {
        apiTitle,
        businessRules,
        requirement: requirementVal,
        openApiSpec,
        endpointURI,
        scenarioType,
        feedbackDesc: feedbackDescription,
        feedbackTags: [feedbackTag] || [],
        feedbackType,
        provider: selectedProvider, 
        model: selectedModel,
        existingTCs: `${JSON.stringify(selected)}`,
        scenarioConvention

      }
    }
    fetch.post({
      url: URL,
      requestBody: RequestBody,
      callbackHandler: (res) => {
        const { status, payload } = res;
        if (APP.Constants.SUCCESS === status) {
          const { totalScore, averageScore } = this.getAggregatedAssessmentScore(JSON.parse(payload?.testcases || payload?.generatedTests || []));
          this.setState({
            testcases: payload?.testcases,
            htmllizedTestcases: payload?.htmllizedTestcases,
            generatedTest: payload?.generatedTests,
            htmlizedTestcases: payload?.htmlizedTestcases,
            assessmentAverageScore: averageScore,
            isLoadingButton: false,
            openModalGeneration: false,
          });
        } else {
          this.setState({
            openErrorModal: true,
            isLoadingButton: false,
            errorMessage: status,
            openModalGeneration: false
          });
        }
        document.querySelectorAll('.tc-checkbox').forEach(cb => cb.checked = true);
      }
    });

  }

  onResponseAccuracy = async () => {
    const _state = cloneDeep(this.state);
    this.setState({ isLoading: true });
    const RequestData = {
      max_prompts: 10,
      complexity: "Medium"
    }
    await axios
      .post(`https://xassure.xebia.in/responseaccuracy/${APP.Constants.SERVICE_URLS.RESPONS_ACCURACY}`, RequestData, { timeout: 30000 })
      // .post(`http://10.10.25.13:5001/${APP.Constants.SERVICE_URLS.RESPONS_ACCURACY}`, RequestData)
      .then((resolve, reject) => {
        _state.accuracy = resolve?.data?.overall_accuracy
        _state.isLoading = false
        this.setState(_state);
      }).catch(err => {
        _state.isLoading = false
        this.setState(_state);
        // alert("There seems some issue. Please try again later");
        toast.error(`${'There seems some issue. Please try again later'}`, { theme: 'colored' });
      });
  }

  onDownloadSave = () => {
    const {
      testCodeOutput,
      programmingLanguage,
      testcases,
      apiTitle,
      startFrom,
      jiraVal,
      businessRules,
      requirementVal,
      requirementTestRadio,
      htmlizedTestcases,
      htmllizedTestcases,
      scenarioConvention,
      scenarioType,
      generatedTest,
      requirementValStep2,
      requirementUnderstanding,
      testid
    } = this.state;
    const userMail = localStorage.getItem("email")
    const orgId = localStorage.getItem('OrgId');
    const projectId = localStorage.getItem('ProjectId');
    fetch.put({
      url: APP.Constants.SERVICE_URLS.GPT_SAVE_API,
      requestBody: {
        requirement: requirementVal,
        appType: requirementTestRadio,
        tcCode: testCodeOutput,
        tcName: apiTitle,
        businessRules,
        scenarioConvention,
        scenarioType,
        startFrom,
        requirementValStep2,
        requirementUnderstanding,
        jiraId: jiraVal,
        tcScenario: testcases || generatedTest,
        htmlTcScenario: requirementTestRadio === 'api' ? htmllizedTestcases : htmlizedTestcases,
        id: testid,
        actionType: 'TestDesign',
        userName: userMail,
        orgId,
        projectId
      },
      callbackHandler: (res) => {
        const { status, payload } = res;
        if (APP.Constants.SUCCESS === status) {
          this.setState({ isLoading: false });
          const url = URL.createObjectURL(
            new Blob([testCodeOutput], {
              type: 'application/file'
            })
          );
          const link = document.createElement('a');
          link.href = url;
          let fileName = 'download';
          fileName = `${payload.tcName || 'AutomationTestCases'}${programmingLanguage === 'Kotlin'
            ? '.kt' : programmingLanguage === 'python'
              ? '.py' : programmingLanguage === 'typescript'
                ? '.ts' : programmingLanguage === 'javascript'
                  ? '.js' : programmingLanguage === 'groovy'
                    ? '.groovy' : programmingLanguage === 'CSharp'
                      ? '.cs' : programmingLanguage === 'dotnet'
                        ? '.net' : '.java'
            }`;
          link.setAttribute('download', fileName);
          document.body.appendChild(link);
          link.click();
          // Stay on the Automation Code step after saving so the user can keep
          // working (regenerate / push to repo) instead of being redirected to
          // the Historical Data list.
          this.setState({ countVal: true, isLoading: false });
          toast.success('✅ Automation code saved & downloaded', { theme: 'colored' });
        } else {
          this.setState({
            openErrorModal: true,
            isLoading: false,
            errorMessage: status
          });
        }
      }
    });
  };

  repoUpload = (type) => {
    const { jiraVal, testcases, programmingLanguage, apiTitle, testCodeOutput, configId } = this.state;
    const projectManagement = localStorage.getItem('projectManagement');
    const activeConfigId = localStorage.getItem('activeConfigId');
    const aceToken = localStorage.getItem('AceToken');
    const orgId = localStorage.getItem('OrgId');
    const aceBackendUrl = localStorage.getItem('AceBackendUrl');
    this.setState({ isLoading: true });
    let fileName;
    if (type === 'manual') {
      fileName = `ManualTest_${jiraVal || ''}.txt`
    } else {
      if (programmingLanguage === 'python') {
        fileName = `${apiTitle || 'Web'}.py`
      } else if (programmingLanguage === 'Kotlin') {
        fileName = `${apiTitle || 'Web'}.kt`
      } else if (programmingLanguage === 'CSharp') {
        fileName = `${apiTitle || 'Web'}.cs`
      } else if (programmingLanguage === 'typescript') {
        fileName = `${apiTitle || 'Web'}.ts`
      } else if (programmingLanguage === 'javascript') {
        fileName = `${apiTitle || 'Web'}.js`
      } else if (programmingLanguage === 'groovy') {
        fileName = `${apiTitle || 'Web'}.groovy`
      } else if (programmingLanguage === 'dotnet') {
        fileName = `${apiTitle || 'Web'}.net`
      } else {
        fileName = `${apiTitle || 'Web'}.java`
      }
    }
    const selected = [];
    document.querySelectorAll('.tc-checkbox:checked').forEach(cb => {
      selected.push(JSON.parse(cb.dataset.json));
    })
    const comment = type === 'manual' ? 'Manual test cases have beed added' : 'Automation test cases have beed added'
    fetch.post({
      url: APP.Constants.SERVICE_URLS.JIRA_COMMENT,
      requestBody: {
        workId: jiraVal,
        projectManagement,
        fileName,  aceToken, orgId, aceBackendUrl,
        configId: activeConfigId,
        // fileContent: type === 'manual' ? testcases : testCodeOutput,
        fileContent: type === 'manual' ? `${JSON.stringify(selected)}` : testCodeOutput,
        comment: comment
      },
      callbackHandler: (res) => {
        const { status, message } = res;
        if (APP.Constants.SUCCESS === status) {
          this.setState({ isLoading: false });
          toast.success('✅ Successfully uploaded!', { theme: 'colored' });
        } else {
          this.setState({ isLoading: false });
          toast.error(`${'Please select any test case...'}`, { theme: 'colored' });
        }
      }
    });
  }

  saveAndExit = () => {
    const { testcases, requirementVal, apiTitle, jiraVal, businessRules, startFrom, requirementTestRadio, requirementUnderstanding, requirementValStep2, htmllizedTestcases, htmlizedTestcases, generatedTest, scenarioConvention, scenarioType } =
      this.state;
    const userMail = localStorage.getItem('email');
    const orgId = localStorage.getItem('OrgId');
    const projectId = localStorage.getItem('ProjectId');
    if (this.state.testid === '') {
      this.setState({ isLoading: true });
      fetch.post({
        url: APP.Constants.SERVICE_URLS.GPT_SAVE_API,
        requestBody: {
          requirement: requirementVal,
          appType: requirementTestRadio,
          tcName: apiTitle,
          jiraId: jiraVal,
          businessRules,
          requirementUnderstanding,
          scenarioConvention,
          scenarioType,
          htmlTcScenario: requirementTestRadio === 'api' ? htmllizedTestcases : htmlizedTestcases,
          startFrom,
          requirementValStep2,
          tcScenario: testcases || generatedTest,
          actionType: 'TestDesign',
          userName: userMail,
          orgId,
          projectId
        },
        callbackHandler: (res) => {
          const { status } = res;
          if (APP.Constants.SUCCESS === status) {
            this.setState({ isLoading: false });
            const jsonData = JSON.parse(JSON.stringify(testcases || generatedTest)); // pretty-print JSON
            const blob = new Blob([jsonData], {
              type: 'application/json'
            });
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            // Use .json extension
            const fileName = `${apiTitle || 'Web'}-${jiraVal || ''}-testScenario.json`;
            link.href = url;
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            // Stay on the current step so the user can continue to automation
            // code generation instead of being sent back to the list.
            this.setState({ testid: res?.payload?.id || this.state.testid });
            toast.success('✅ Test scenarios saved & downloaded', { theme: 'colored' });
          } else {
            this.setState({
              openErrorModal: true,
              isLoading: false,
              errorMessage: status
            });
          }
        }
      });
    } else {
      // const url = URL.createObjectURL(
      //   new Blob([testcases], {
      //     type: 'application/file'
      //   })
      // );
      // const link = document.createElement('a');
      // link.href = url;
      // let fileName = 'download';
      // fileName = `${apiTitle}-${jiraVal}-testScenario.docx`;
      // link.setAttribute('download', fileName);
      // document.body.appendChild(link);
      // link.click();
      // sessionStorage.removeItem('checkId');
      fetch.put({
        url: APP.Constants.SERVICE_URLS.GPT_SAVE_API,
        requestBody: {
          requirement: requirementVal,
          appType: requirementTestRadio,
          tcName: apiTitle,
          jiraId: jiraVal,
          businessRules,
          requirementUnderstanding,
          scenarioConvention,
          scenarioType,
          id: this.state.testid,
          htmlTcScenario: requirementTestRadio === 'api' ? htmllizedTestcases : htmlizedTestcases,
          startFrom,
          requirementValStep2,
          tcScenario: testcases || generatedTest,
          actionType: 'TestDesign',
          userName: userMail,
          orgId,
          projectId
        },
        callbackHandler: (res) => {
          const { status } = res;
          if (APP.Constants.SUCCESS === status) {
            this.setState({ isLoading: false });
            const jsonData = JSON.parse(JSON.stringify(testcases || generatedTest)); // pretty-print JSON
            const blob = new Blob([jsonData], {
              type: 'application/json'
            });
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            // Use .json extension
            const fileName = `${apiTitle || 'Web'}-${jiraVal || ''}-testScenario.json`;
            link.href = url;
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            // Stay on the current step (no redirect to the list).
            toast.success('✅ Test scenarios saved & downloaded', { theme: 'colored' });
          } else {
            this.setState({
              openErrorModal: true,
              isLoading: false,
              errorMessage: status
            });
          }
        }
      });
    }
  };

  redirectToViewPage = () => {
    sessionStorage.removeItem('checkId');
    this.props.goToPage(APP.Constants.ROUTES.VIEW_REQUIREMENT);
  }

  render() {
    return (
      <TestDesignView
        {...{
          ...this.state,
          onChange: this.onChange,
          onCancel: this.onCancel,
          isEditorEmpty: this.isEditorEmpty,
          onCancelStep2: this.onCancelStep2,
          onAbort: this.onAbort,
          onDone: this.onDone,
          onAnalyze: this.onAnalyze,
          openNewModal: this.openNewModal,
          closeNewModal: this.closeNewModal,
          onDownloadSave: this.onDownloadSave,
          reGenerateCode: this.reGenerateCode,
          feedbackRequirement: this.feedbackRequirement,
          closePopup: this.closePopup,
          onUpload: this.onUpload,
          closeErrorPopup: this.closeErrorPopup,
          openPopup: this.openPopup,
          saveAndExit: this.saveAndExit,
          generateCode: this.generateCode,
          gotoStep2Data: this.gotoStep2Data,
          reGenerateScenario: this.reGenerateScenario,
          assessQuality: this.assessQuality,
          gotoStep3Data: this.gotoStep3Data,
          backtostep1: this.backtostep1,
          backtostepui1: this.backtostepui1,
          backtostepui2: this.backtostepui2,
          backtostep2: this.backtostep2,
          repoUpload: this.repoUpload,
          handleChangellm: this.handleChangellm,
          submitRequirement: this.submitRequirement,
          redirectToAnotherPage: this.redirectToAnotherPage,
          onChangeRadioButton: this.onChangeRadioButton,
          onResponseAccuracy: this.onResponseAccuracy,
          redirectToViewPage: this.redirectToViewPage,
          handleFile: this.handleFile
        }}
      />
    );
  }
}

export default TestDesignComponent;
